import { Col, InputNumber, Row } from "antd";
import { useVolSurfaceControlTable } from "contexts/VolSurfaceControlTableContext";
import { storeInLocalStorage } from "helpers/Pricer/Table";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function AverageAndCostOfCarry({
  dark_Theme,
  average,
  setAverage,
  costOfCarry,
  setCostOfCarry,
  disabledCondition,
  selectedFilters,
  notTrader
}) {
  const location = useLocation();
  const { stickyStrikeData, lockedData } = useVolSurfaceControlTable();

  const pathName = location.pathname;
  const isVolSurfacePage = pathName.includes("vol-surface");
  const hideDateFilterOnProdForVolSurface = !isVolSurfacePage;

  function handleAverageChange(value) {
    storeInLocalStorage("AverageAndCostOfCarryIsReloaded", JSON.stringify(false));
    setAverage(value || 0);
  }
  function handleCostOfCarryChange(value) {
    storeInLocalStorage("AverageAndCostOfCarryIsReloaded", JSON.stringify(false));
    setCostOfCarry(value || 0);
  }

  useEffect(() => {
    storeInLocalStorage("AverageAndCostOfCarryIsReloaded", JSON.stringify(true));

    return () => {
      storeInLocalStorage("AverageAndCostOfCarryIsReloaded", JSON.stringify(true));
    }
  },[])



  return (
    <Col span={24}>
      <Row gutter={[25, 25]} style={{ marginBottom: 20 }}>
        <Col span={3}>Cost of Carry: </Col>
        <Col>
          <InputNumber
            min={0}
            placeholder="0.00"
            inputMode="numeric"
            addonAfter={"%"}
            className={`${
              disabledCondition || !notTrader
                ? dark_Theme
                  ? "ant-input-number-dark-disabled"
                  : "ant-input-number-light-disabled"
                : dark_Theme
                ? "ant-input-number-dark"
                : "ant-input-number-light"
            } w-100 `}
            disabled={
              lockedData?.is_locked ||
              disabledCondition || !notTrader ||
              (stickyStrikeData?.is_surface_locked &&
                !hideDateFilterOnProdForVolSurface)
            }
            value={costOfCarry}
            onChange={(value) => handleCostOfCarryChange(value)}
          />
        </Col>
      </Row>
      <Row gutter={[25, 25]}>
        <Col span={3}>Average: </Col>
        <Col>
          <InputNumber
            placeholder="0"
            min={0}
            className={`${
              disabledCondition || !notTrader
                ? dark_Theme
                  ? "ant-input-number-dark-disabled"
                  : "ant-input-number-light-disabled"
                : dark_Theme
                ? "ant-input-number-dark"
                : "ant-input-number-light"
            } w-100 `}
            disabled={
              lockedData?.is_locked ||
              disabledCondition || !notTrader ||
              (stickyStrikeData?.is_surface_locked &&
                !hideDateFilterOnProdForVolSurface)
            }
            value={average}
            onChange={(value) => handleAverageChange(value)}
            inputMode="numeric"
          />
        </Col>
      </Row>
    </Col>
  );
}
